// extracted by mini-css-extract-plugin
export default {"logoSection":"VendorLogoField_logoSection__thH3A","logoHeader":"VendorLogoField_logoHeader__XEhVD","previewPlaceholder":"VendorLogoField_previewPlaceholder__7fqPd"};